import { apiRequest } from "./http"

/**
 * Восстановление доступа с экрана входа.
 *
 * ОТВЕТ ВСЕГДА ОДИНАКОВЫЙ — 202 «accepted», есть такой адрес или нет
 * (apps/api/src/modules/auth/auth.controller.ts, requestReset). Это не небрежность
 * сервера, а то же правило, по которому вход отвечает одним кодом на три разные беды:
 * разный ответ превращает форму в перечислитель сотрудников салона.
 *
 * Следствие для экрана: карточка «Письмо ушло на a•••@mail.ru» показывается ВСЕГДА,
 * и подтверждением существования учётки она не является.
 */
export function requestPasswordReset(email: string): Promise<{ readonly status: string }> {
  return apiRequest<{ status: string }>("/cabinet/auth/password/reset", {
    method: "POST",
    body: { email },
    authenticated: false,
  })
}

/**
 * Задать новый пароль по ссылке из письма.
 *
 * Отказ invalid_credentials здесь означает ровно одно — ссылка не подошла: просроченная,
 * использованная и выдуманная неразличимы намеренно (по ответу нельзя узнать, была ли
 * ссылка настоящей). Текст про «проверьте адрес и пароль» на этом экране был бы про
 * другое, поэтому экран разбирает код сам.
 */
export function confirmPasswordReset(token: string, newPassword: string): Promise<void> {
  return apiRequest<void>("/cabinet/auth/password/reset/confirm", {
    method: "POST",
    body: { token, newPassword },
    authenticated: false,
  })
}
